/* @flow */
import React, {PureComponent} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import SearchReviews from '../SearchReviews/SearchReviews';
import {MoreOrLess} from '@homeaway/react-collapse';
import gql from 'graphql-tag';

import type {SearchReviewSummary as SearchReviewSummaryShape} from '../../components/SearchReviews/SearchReviews';
import {fragments as searchReviewsFragment} from '../SearchReviews/SearchReviews';

import './SeoContent.less';

type Props = {
    searchReviewsHeadline: ?string,
    topRecentReviews: SearchReviewSummaryShape[]
};
// We skip topRecentReviews for GTS. If it will be needed just add SeoContentSearchResult fragment to SearchRequestQuery
export const fragments = {
    searchResult: gql`
        fragment SeoContentSearchResult on SearchResult {
            topRecentReviews {
                ...SearchReviewsTopRecentReviewSummary
            }
        }
        ${searchReviewsFragment.topRecentReviewSummary}
    `
};

export class SeoContent extends PureComponent<Props> {
    render() {
        const {searchReviewsHeadline, topRecentReviews} = this.props;
        return (
            <div className={'SeoContent'} data-wdio={'SeoContent'}>
                <MoreOrLess
                    id="SeoContent__more-or-less"
                    lines={6}
                    lessText={
                        <FormattedMessage
                            defaultMessage="Show less"
                            id="showLessLabel"
                        />
                    }
                    moreText={
                        <FormattedMessage
                            defaultMessage="Show more"
                            id="showMoreLabel"
                        />
                    }
                >
                    <div className={'SeoContent__search-reviews-section'}>
                        {searchReviewsHeadline && (
                            <h2>{searchReviewsHeadline}</h2>
                        )}
                        <SearchReviews reviews={topRecentReviews} />
                    </div>
                </MoreOrLess>
            </div>
        );
    }
}

export default injectIntl(SeoContent);
